module.exports = __webpack_public_path__ + "static/media/people.b5c7ff0d.svg";